// @flow

import {
  UPLOAD_EVIDENCE_FAILURE,
  UPLOAD_EVIDENCE_REQUEST,
  UPLOAD_EVIDENCE_SUCCESS
} from '../actions/evidence';

export type EvidenceState = {
  isUploadingEvidence: boolean,
  evidenceError: ?string
};

const initialState: EvidenceState = {
  isUploadingEvidence: false,
  evidenceError: null
};

export default function evidenceReducer(
  state: EvidenceState = initialState,
  action: any
): EvidenceState {
  switch (action.type) {
    case UPLOAD_EVIDENCE_REQUEST:
      return {
        ...state,
        isUploadingEvidence: true,
        evidenceError: null
      };

    case UPLOAD_EVIDENCE_SUCCESS:
      return {
        ...state,
        isUploadingEvidence: false,
        evidenceError: null
      };

    case UPLOAD_EVIDENCE_FAILURE:
      return {
        ...state,
        isUploadingEvidence: false,
        evidenceError: action.payload.error
      };

    default:
      return state;
  }
}
